<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="aafb/admin/recurrent_bookings/"
                       data-key="booking_records"
                       :extra-params="combinedExtraParams"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       hide-select-all
                       v-bind="$attrs">
    <template #item.reference_number="{value}">
      {{ value ? `BV${value.toString().padStart(10, "0")}` : $t('admin_acc_booking_add.maintenance_booking') }}
    </template>
    <template #item.hkiarace_account="{value}">
      {{ value ? $t('name', {given_name: value.given_name, surname: value.surname}) : '' }}
    </template>
    <template #item.create_at="{value}">
      {{ $parseDate(value) }}
    </template>
    <template v-slot:item.actions="{item}">
      <v-row v-if="!hideActions">
        <v-col v-if="!hideQuickCreatePo">
          <v-tooltip top>
            <template #activator="{on, attrs}">
              <v-btn icon
                     v-on="on"
                     v-bind="attrs"
                     @click="quickCreatePo(item)">
                <v-icon>mdi-cart-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('admin_acc_recurrent_booking.quick_create_po') }}</span>
          </v-tooltip>
        </v-col>
        <v-col v-if="!hideEdit">
          <v-tooltip top>
            <template #activator="{on, attrs}">
              <v-btn icon
                     v-on="on"
                     v-bind="attrs"
                     @click="editItem(item)">
                <v-icon>fas fa-search</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('detail') }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </template>
  </RemotePaginatedList>
</template>

<script>
import _ from 'lodash';
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";
import {BOOKING_STATUS, BOOKING_STATUS_LABEL} from "@/constants";
import EditRecurringBookingModal from "@/components/acc_booking/booking/EditRecurringBookingModal.vue";
import AddPurchaseOrderModal from "@/components/acc_booking/purchase_order/AddPurchaseOrderModal.vue";

export default {
  name: 'AdminRecurrentBookingList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    hideSearch: Boolean,
    showSelect: Boolean,
    refreshTrigger: Boolean,
    hideEdit: Boolean,
    hideQuickCreatePo: Boolean,
    hideActions: Boolean,
    userId: String,
    itemId: String,
    extraParams: Object,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    const combinedExtraParams = computed(() => {
      return {
        user_id: props.userId,
        item_id: props.itemId,
        ...props.extraParams,
      }
    })

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        {text: root.$t('admin_acc_booking.reference_number'), value: 'reference_number', contains: true},
        {text: root.$t('admin_acc_booking_add.recur_title'), value: 'recurrent_title', contains: true},
        {text: root.$t('admin_user.serial_no'), value: 'booking_record.account.hkiarace_account.id', contains: true},
        {text: root.$t('admin_acc_booking.reserved_at'), value: 'create_at', date_range: true},
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_acc_booking.reserved_at'), value: 'create_at'},
      {text: root.$t('admin_acc_booking.reference_number'), value: 'reference_number', sortable: false},
      {text: root.$t('admin_acc_booking_add.recur_title'), value: 'recurrent_title', sortable: false},
      {text: root.$t('admin_user.serial_no'), value: 'hkiarace_account.serial_no', sortable: false},
      {text: root.$t('admin_acc_member.title'), value: 'hkiarace_account', sortable: false},

      {text: '', value: 'actions', sortable: false},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const quickCreatePo = async function (item) {
      const needRefresh = await root.$dialog.showAndWait(AddPurchaseOrderModal, {
        showClose: false,
        persistent: true,
        width: '80vw',

        bookingRecordId: item.id,
      });

      if (needRefresh) {
        refresh();
      }
    }

    const editItem = async function (item) {
      await root.$dialog.showAndWait(EditRecurringBookingModal, {
        bookingRecordId: item.id,
        persistent: true,
        width: '80vw',
      })
    };

    return {
      combinedExtraParams,

      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      BOOKING_STATUS,
      BOOKING_STATUS_LABEL,

      quickCreatePo,
      editItem,
    }
  }
}
</script>
